export default __webpack_public_path__ + "80823293317f1ef5df307678ec566d50.woff";